import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Column } from '../../../report/models/column.model';
import { getMaxLength } from '../functions/dynamic-rows';

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrls: ['./report-header.component.scss']
})
export class ReportHeaderComponent implements OnInit {

  @Input() columns : Array<Column> = []

  @Input('fontWeight') weight : number;
  @Input() columnsMaxLength: Map<string,number>;

  style : any = {}

  constructor() { }

  ngOnInit() {
  }

  getMaxLength(column): string {
    return getMaxLength(column, this.columnsMaxLength, column.Alias.length);
  }
}
